import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSymbol } from "../../api/request/dashboard/dashboard";

export const fetchSymbols = createAsyncThunk('Symbols/get', async (_, { getState }) => {
    console.log("Hello ")
    const clientId = getState().user?.userDetail?.id
    try {
        const { data } = await getSymbol(clientId)
        const rowData = {}
        data?.forEach((update) => {
            rowData[update?.id] = { ...update };
        });
        console.log(rowData)
        return rowData
    } catch (err) {
        return {};
    }
})